import { useEffect } from 'react'

/**
 * Calls `handler` when a mousedown occurs outside the element pointed to by `ref`.
 * Pass `enabled=false` to disable without unmounting.
 */
export function useClickOutside(ref, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return
    const onMouseDown = (e) => {
      if (!ref.current) return
      if (ref.current.contains(e.target)) return
      handler(e)
    }
    document.addEventListener('mousedown', onMouseDown)
    return () => document.removeEventListener('mousedown', onMouseDown)
  }, [ref, handler, enabled])
}
